import type { CollaboratorEppnDto } from '@/api/ApiClient';

export type EppnFormRow = {
  key: string;
  id?: number;
  eppn: string;
  /** Empty string = no expiry; otherwise YYYY-MM-DD for date input. */
  expiresAt: string;
};

function formatExpiresAtForInput(value: Date | string | undefined): string {
  if (!value) {
    return '';
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  return d.toISOString().slice(0, 10);
}

/** Builds editable EPPN rows from API data. */
export function initEppnFormRows(params: {
  eppns?: CollaboratorEppnDto[] | undefined;
  isEdit: boolean;
}): EppnFormRow[] {
  const { eppns, isEdit } = params;

  if (isEdit && eppns?.length) {
    return eppns.map((row, index) => ({
      key: String(row.id ?? `new-${index}`),
      id: row.id,
      eppn: row.eppn ?? '',
      expiresAt: formatExpiresAtForInput(row.expiresAt),
    }));
  }

  return [{ key: '0', eppn: '', expiresAt: '' }];
}

/** Maps form rows to API replace-semantics payload. */
export function eppnFormRowsToDto(rows: EppnFormRow[]): CollaboratorEppnDto[] {
  return rows
    .map((row) => ({
      id: row.id,
      eppn: row.eppn.trim() || undefined,
      expiresAt: row.expiresAt.trim() ? new Date(`${row.expiresAt.trim()}T00:00:00Z`) : undefined,
    }))
    .filter((row) => row.eppn);
}
